import { useNavigate, useParams } from 'react-router-dom'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const BlockSendSurveyModal = () => {
  const navigate = useNavigate()
  const { id, formId } = useParams<{ id: string; formId: string }>()

  const { navigation } = useNavigation()

  const onCloseRoute =
    navigation.trainings.list.details_revamp.trainingSurveyDetail.questions.fullPath({
      id: Number(id),
      formId: Number(formId),
    })

  return (
    <Modal
      title={i18n.t('trainings.surveys.create.blocked_send_survey.title')}
      description={i18n.t('trainings.surveys.create.blocked_send_survey.description')}
      illustration="document-edit"
      onClose={() => navigate(onCloseRoute)}
    />
  )
}

export default BlockSendSurveyModal
